module.exports = __webpack_public_path__ + "static/img/普通开户.29ccfbcd.svg";